// extracted by mini-css-extract-plugin
export default {"ButtonReturn":"ReturnButton_ButtonReturn__jWlpq"};